import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILoginResponse } from "interfaces/ApiInterface/ILoginFormData";

interface LoginPageState {
  user: ILoginResponse | null;
  staticUser:{
    id: number,
    firstName: string,
    lastName: string,
    imgUrl: string,
    userName: string,
  } | null
}

const initialState: LoginPageState = {
  user: null,
  staticUser: null
};

const userSlice = createSlice({
  name: "userDetail",
  initialState,
  reducers: {
    setUserDetail: (state, action: PayloadAction<ILoginResponse>) => {
      state.user = action.payload;
    },
    setUser:(state, action)=>{
      state.staticUser = action.payload;
    }
  },
});

export const { setUserDetail, setUser } = userSlice.actions;
export default userSlice.reducer;
